import { useTranslation } from 'react-i18next';

import type { FieldErrorMap } from '@/lib/kbFieldErrors';

interface FieldErrorProps {
  errors: FieldErrorMap | null;
  /** Flattened Marshmallow path, e.g. `policies` or `faq.1.answer`. */
  path: string;
}

/**
 * F071 — per-field 422 message rendered directly below the offending
 * input. Length violations name the exact cap; anything else gets a short
 * owner-friendly "invalid value" (never the raw server message).
 */
export function FieldError({ errors, path }: FieldErrorProps) {
  const { t } = useTranslation();
  const detail = errors?.[path];
  if (!detail) return null;
  return (
    <p className="text-xs text-destructive" role="alert">
      {detail.maxLength != null
        ? t('common.field_too_long', { max: detail.maxLength })
        : t('common.field_invalid')}
    </p>
  );
}
